// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__4VfmD","footer":"ModalInfo_footer__15QiD"};